<div class="container">
  <div class="row">
    <div class="col-lg-10 mx-auto">
      <div class="bg-white rounded-4 p-5">
        <h2 class="text-primary fw-500 mb-2">Get started With Treasure Hill</h2>
        <p class="text-muted">Please select your role to continue.</p>
        <hr class="text-muted mb-3" />

        <div class="mb-0 mt-4">
          <h3 class="mb-3 fw-500 mt-3 mb-3">Are you a prospect or a realtor?</h3>

          <div
            class="btn-group d-flex justify-content-center gap-3 w-100 mt-3"
            role="group"
            aria-label="User Type Selection"
          >
            <button
              class="btn btn-outline-primary btn-h45 flex-fill justify-content-center"
              (click)="selectedType.set('prospect'); onSaveButtonClick()"
            >
              Prospect
            </button>
            <button
              class="btn btn-outline-primary btn-h45 flex-fill justify-content-center"
              (click)="selectedType.set('realtor'); onSaveButtonClick()"
            >
              Realtor
            </button>
          </div>
          <!-- <div class="d-flex flex-column gap-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="userType"
                id="prospect"
                value="prospect"
                [checked]="selectedType() === 'prospect'"
                (change)="selectedType.set('prospect')"
              />
              <label class="form-check-label" for="prospect"> Prospect </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="userType"
                id="realtor"
                value="realtor"
                [checked]="selectedType() === 'realtor'"
                (change)="selectedType.set('realtor')"
              />
              <label class="form-check-label" for="realtor"> Realtor </label>
            </div>
          </div> -->
        </div>

        <!-- <button
          class="btn btn-primary text-center btn-h45 mt-3 btn-prosp-submit justify-content-center w-100"
          (click)="onSaveButtonClick()"
          [disabled]="!selectedType()"
        >
          Continue
        </button> -->
      </div>
    </div>
  </div>
</div>
